import { IDichVuSelectRequest } from '../../models/request/dich-vu/dichVuRequests';
import { sf_khoannop_group } from '../../models/response/dich-vu/sf_khoannop_group';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_KHOANNOP_GROUP_PATH = "sf-khoannop-group";

/** Body của `sf-khoannop-group/select-by-hs` */
export interface IKhoanNopGroupSelectByHocSinhRequest extends IDichVuSelectRequest {
	ts_hocsinh_id: number;
}

export interface IKhoanNopGroupGetKhoanNopRequest {
	truong_id: number;
	khoi_id: number;
	he_id: number;
	nam_hoc: string;
	co_so: number;
	hoc_sinh: number;
}

class KhoanNopGroupApi extends BaseCRUDApi<sf_khoannop_group> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectIsDichVu(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/sf-khoannop-group`);
	}
	SelectByHocSinh(request: IKhoanNopGroupSelectByHocSinhRequest) {
		return apiClient.post(`sf-khoannop-group/select-by-hs`, request);
	}
	GetKhoanNop(request: IKhoanNopGroupGetKhoanNopRequest) {
		return apiClient.get(
			`sf-khoannop-group/get-khoan-nop?truong_id=${request.truong_id}&khoi_id=${request.khoi_id}&he_id=${request.he_id}&nam_hoc=${request.nam_hoc}&coso=${request.co_so}&hoc_sinh=${request.hoc_sinh}`
		);
	}
	InsertKhoanThu(formData: any) {
		return apiClient.post(`sf-khoannop-group/insert-khoan-thu`, formData);
	}
	CheckPaymentStatus(formData: any) {
		return apiClient.post(`sf-khoannop-group/check-payment-status`, formData);
	}
}
export const khoanNopGroupApi = new KhoanNopGroupApi(API_KHOANNOP_GROUP_PATH);
